module.exports = __webpack_public_path__ + "img/16-3-4.6f1f7b23.png";